import { cn } from '@/shared/lib/cn';
import { HelpCircle, MessageSquare, Users } from 'lucide-react';
import type { TicketStatus } from '../types';

interface Props {
  active: TicketStatus;
  counts: { active: number; pending: number; closed: number };
  onChange: (s: TicketStatus) => void;
}

const TABS: Array<{
  status: TicketStatus;
  label: string;
  icon: typeof MessageSquare;
  badgeVariant?: 'warn' | 'zero';
  /** false = não mostra badge (ex: Fechados pode ter milhares, contador
   *  não agrega valor pra UX e poluiria visual). */
  showBadge?: boolean;
}> = [
  { status: 'active', label: 'Ativos', icon: MessageSquare, showBadge: true },
  { status: 'pending', label: 'Pendentes', icon: HelpCircle, badgeVariant: 'warn', showBadge: true },
  { status: 'closed', label: 'Fechados', icon: Users, showBadge: false },
];

export function InboxTabs({ active, counts, onChange }: Props) {
  return (
    <div className="flex gap-1 border-b border-n-200 px-2">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const count = counts[tab.status] ?? 0;
        const isActive = active === tab.status;
        const badgeClass =
          count === 0
            ? 'bg-n-300 text-n-700'
            : tab.badgeVariant === 'warn'
              ? 'bg-brand-500 text-white'
              : 'bg-danger-500 text-white';
        return (
          <button
            key={tab.status}
            type="button"
            onClick={() => onChange(tab.status)}
            className={cn(
              '-mb-px relative flex flex-1 items-center justify-center gap-2 border-b-2 px-1.5 pt-[13px] pb-[12px] font-semibold text-[12px]',
              isActive
                ? 'border-brand-500 text-brand-600'
                : 'border-transparent text-n-500 hover:text-n-700',
            )}
          >
            <span className="relative flex h-[22px] w-[22px] items-center justify-center">
              <Icon
                size={18}
                strokeWidth={1.75}
                className={isActive ? 'text-brand-600' : 'text-n-500'}
              />
              {tab.showBadge && (
                <span
                  className={cn(
                    'absolute top-[-8px] right-[-12px] inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-pill border-2 border-white px-[5px] font-bold text-[10px] leading-none',
                    badgeClass,
                  )}
                >
                  {count}
                </span>
              )}
            </span>
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
